// Match scss vars
const viewport = {
  s: window.matchMedia(`(min-width: ${576 / 16}em)`),
  m: window.matchMedia(`(min-width: ${768 / 16}em)`),
  l: window.matchMedia(`(min-width: ${992 / 16}em)`),
  xl: window.matchMedia(`(min-width: ${1200 / 16}em)`),
  xxl: window.matchMedia(`(min-width: ${1500 / 16}em)`)
};

const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

const saveData =
  'connection' in navigator && navigator.connection.saveData === true;

export { viewport, reducedMotion, saveData };
